import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Pagination from '@material-ui/lab/Pagination';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { connect } from 'react-redux';
import { getAllEventsByIp } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
const PAGE_LIMIT = 2000
const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const AllEventsByIpTable = (props) => {
  const classes = useStyles();
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [page, setPage] = useState(1);


  useEffect(() => {
    const ip = props.match.params.ip
    props.getAllEventsByIp(ip);
  }, []);


  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Events
        </h4>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Event</th>
            <th>IP</th>
            <th>City</th>
            <th>Country</th>
            <th>IpType</th>
            <th>ISP</th>
            <th>Region</th>
            <th>Location</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {props.allEventsByIp?.map((item, i) => (
            <tr key={item._id}>
              <th scope="row">{i + 1 + (page ? (page - 1) * PAGE_LIMIT : 0)}</th>
              <td>{item.event}</td>
              <td>{item.query}</td>
              <td>{item.city}</td>
              <td>{item.country}</td>
              <td>{item.ipType}</td>
              <td>{item.isp}</td>
              <td>{item.region}</td>
              <td>{item.location}</td>
              <td>{new Date(parseInt(item.createdAt)).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allEventsByIp: state.admin.allEventsByIp,
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllEventsByIp: (ip) => dispatch(getAllEventsByIp(ip)),
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(AllEventsByIpTable);
